export default __webpack_public_path__ + "static/media/apple-icon.69dd2542.svg";